
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/search-by/[slug]",
      function () {
        return require("private-next-pages/blog/search-by/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/search-by/[slug]"])
      });
    }
  